<template>
  <div class="notification">
    <nav class="level is-mobile">
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Öl</p>
          <p class="title">{{ numberOfBeersTested }}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Bryggerier</p>
          <p class="title">{{ numberOfBreweries }}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Tillfällen</p>
          <p class="title">{{ numberOfBeerTastings }}</p>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  computed: {
    numberOfBeersTested () {
      return this.$store.getters.numbersOfBeersTested
    },
    numberOfBreweries () {
      return this.$store.getters.breweriesCount
    },
    numberOfBeerTastings () {
      return this.$store.getters.beerTastings
    }
  }
}
</script>



// WEBPACK FOOTER //
// TopFacts.vue?d170f5b6